var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTick(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 13,
    viewBox: "0 0 17 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.2452 0.500458C14.3415 0.402145 14.4565 0.324042 14.5835 0.270724C14.7104 0.217405 14.8466 0.189941 14.9843 0.189941C15.122 0.189941 15.2582 0.217405 15.3851 0.270724C15.5121 0.324042 15.6271 0.402145 15.7234 0.500458C16.1272 0.908487 16.1329 1.56783 15.7375 1.98292L7.38918 11.8518C7.2944 11.9559 7.17937 12.0396 7.05115 12.0977C6.92292 12.1558 6.78419 12.1871 6.64344 12.1898C6.50269 12.1924 6.36288 12.1663 6.23257 12.1131C6.10225 12.0598 5.98417 11.9805 5.88554 11.8801L0.805657 6.73243C0.609743 6.53263 0.5 6.26396 0.5 5.98414C0.5 5.70431 0.609743 5.43565 0.805657 5.23585C0.902011 5.13754 1.01701 5.05943 1.14392 5.00611C1.27084 4.9528 1.40711 4.92533 1.54477 4.92533C1.68243 4.92533 1.8187 4.9528 1.94561 5.00611C2.07253 5.05943 2.18752 5.13754 2.28388 5.23585L6.59289 9.60275L14.217 0.531519C14.2257 0.520608 14.2352 0.510236 14.2452 0.500458Z",
    fill: "#2CD3A1"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTick);
export default __webpack_public_path__ + "static/media/tick.be76d6ab.svg";
export { ForwardRef as ReactComponent };